<template>
  <v-container class="productDetailsContainer pt-0">
   <v-toolbar class="categoriesHeader" elevation="0"
    >
     <v-icon @click="goBack">
       mdi-chevron-left
     </v-icon>


     <v-toolbar-title class="pageTitle">
       Artikeldetails
     </v-toolbar-title>
    </v-toolbar>

    <v-card class="articleCard productDetails pa-5" elevation="0" v-if="!isLoading">

      <div v-if="!notFound">
        <div class="detailsRibbonWrap"
             v-if="article.price.length > 0 && article.price[0].action === 1"
        >
          <span class="detailsRibbon">
            Aktion
          </span>
        </div>

          <v-avatar class="productImageDetails" tile size="22vh">
            <!---
            <v-img lazy-src="" :src="productImage" contain
            >
            -->
            <v-img :src="baseUrl + 'storage/webps/'+ (article.itemNo.indexOf('-') > -1 ? article.itemNo.substr(0, article.itemNo.indexOf('-')) : article.itemNo)+'.webp'"
                   lazy-src=""
                   contain
            >
              <template v-slot:placeholder>
                <v-skeleton-loader type="avatar" tile size="22vh">

                </v-skeleton-loader>
              </template>
            </v-img>
            <v-avatar v-if="article.fsk" class="fskAvatar" tile size="5vh">
              <fsk18/>
            </v-avatar>
          </v-avatar>

        <v-container class="articleCard__container">
          <v-row class="articleCard__details" v-if="getPermissions && getPermissions.indexOf('PRODSTANDARD') > -1">
            <v-col cols="12" class="articleName">
              {{ article.description }}
            </v-col>
            <v-col cols="12" class="articleName2" v-if="article.description2 !== null">
              {{ article.description2 }}
            </v-col>
            <div class="articleAdditionalInfo articleAdditionalInfoWrapper">
              <v-col cols="12">
                <span>Artikelnummer: {{ article.itemNo }}</span>
              </v-col>
            </div>
            <v-col class="articleAdditionalInfo" cols="12" v-if="articleInCart">
              <span>Artikel ist bereits im Warenkorb</span>
            </v-col>
            <v-col class="articleAdditionalInfo" cols="12" v-if="!articleInCart && latestOrderDate !== null">
              <span>Artikel wurde zuletzt am {{ latestOrderDate }} bestellt</span>
            </v-col>
            <v-col cols="12" v-if="article.availability==='G'" class="articleStatusCol">
              <div class="articleAvailable"></div>
              <span class="articleStatusAvailable">Artikel ist lieferbar</span>
            </v-col>
            <v-col cols="12" v-if="article.availability ==='R'" class="articleStatusCol">
              <div class="articleNotAvailable"></div>
              <span class="articleStatusNotAvailable"
                    v-if="!article.delisted"
              >
                Artikel ist derzeit nicht lieferbar
              </span>
              <span class="articleStatusNotAvailable"
                    v-if="article.delisted"
              >
                Artikel ist ausgelistet
              </span>
            </v-col>
            <v-col cols="12" v-if="article.availability==='Y'" class="articleStatusCol">
              <div class="articlePending"></div>
              <span class="articleStatusPending">Bestellartikel - wird nach Eintreffen automatisch ausgeliefert</span>
            </v-col>

            <span :class="[parseArtNrFromInfo(article.infoText) !== 0 ? articleInfoTextRedirect : '', articleStatusNotAvailable]"
                  v-if="article.infoText !== null && article.availability !== 'Y'"
                  @click="parseArtNrFromInfo(article.infoText) !== 0 ? goToArticle(parseArtNrFromInfo(article.infoText)) : ''"
            >
              {{ article.infoText }}
            </span>
            <v-col cols="12" class="articlePriceCol" v-if="article.price.length > 0">
              <span class="articlePriceMain">{{ article.price[0].price | parsePrice }} €</span>
              <span class="articlePriceUVP ml-2" v-if="article.price[0].uvp !== null"> UVP: {{ article.price[0].uvp | parsePrice }} €</span>
              <span class="articlePriceUVP ml-2" v-if="article.price[0].uvp === null && article.default_price.uvp !== null && article.default_price.uvp > 0"> UVP: {{ article.default_price.uvp | parsePrice }} €</span>
            </v-col>
            <v-col cols="12" class="articlePriceCol" v-if="article.price.length === 0">
              <span class="articlePriceMain" v-if="article.default_price !== null">{{ article.default_price.uvp | parsePrice }} €</span>
              <span class="articlePriceUVP ml-2" v-if="article.default_price !== null"> UVP: {{ article.default_price.uvp | parsePrice }} €</span>
            </v-col>
            <v-col cols="12" class="articleRefUnitCol" v-if="article.price.length > 0">
              <span class="articleRefUnitPrice" v-if="article.packageItem === '0'"> {{ article.price[0].price*article.refFactor | parsePrice}}€ / {{ article.refUnit }}</span>
              <span class="articleRefUnitPrice" v-if="article.packageItem === '1'"> {{ article.price[0].price/article.baseUnitInPackage*article.refFactor | parsePrice}}€ / {{ article.refUnit }}</span>
            </v-col>
            <v-col cols="12" class="articleRefUnitCol" v-if="article.price.length === 0 && article.default_price !== null">
              <span class="articleRefUnitPrice" v-if="article.packageItem === '0' && article.default_price.uvp > 0"> {{ article.default_price.uvp*article.refFactor | parsePrice}}€ / {{ article.refUnit }}</span>
              <span class="articleRefUnitPrice" v-if="article.packageItem === '1' && article.default_price.uvp > 0"> {{ article.default_price.uvp/article.baseUnitInPackage*article.refFactor | parsePrice}}€ / {{ article.refUnit }}</span>
            </v-col>
          </v-row>

          <v-row class="articleCard__details" v-if="getPermissions && getPermissions.indexOf('LAGER') > -1">
            <v-col cols="12" class="articleName">
              {{ article.description }}
            </v-col>
            <v-col cols="12" class="articleName2" v-if="article.description2 !== null">
              {{ article.description2 }}
            </v-col>
            <div class="articleAdditionalInfo articleAdditionalInfoWrapper">
              <v-col cols="12">
                <span>Artikelnummer: {{ article.itemNo }}</span>
              </v-col>
              <v-col cols="12" style="font-size: 18px; margin-top: 15px;">
                <span><strong>Lagerplatz:</strong> {{ article.shelfNo ?  article.shelfNo : 'keine Daten vorhanden.'}}</span>
              </v-col>
            </div>

          </v-row>
        </v-container>
        <v-btn v-if="!getWatched"
               class="watchListBtn"
               elevation="0"
               @click="setToWatchList"
        >
          <div class="watchListContent">
            <notesSmall/>
            <span>Merken</span>
          </div>
        </v-btn>
        <v-btn  v-if="getWatched"
                class="watchListBtn"
                elevation="0"
                @click="setToWatchList"
        >
          <div class="watchListContent">
            <span>Entfernen</span>
          </div>
        </v-btn>
        <portal to="addCart" class="addCart">
          <addToCart :article="article"/>
        </portal>

        <portal to="addInventory" class="addCart">
          <addToInventory :article="article"/>
        </portal>

        <portal to="addLabel">
          <addToLabels :article="article"/>
        </portal>


        <portal to="addToMHDList">
            <add-to-m-h-d-inventory :article="article"/>
        </portal>
      </div>

      <div v-if="notFound">
        Artikel konnte leider nicht gefunden werden
      </div>

    </v-card>
    <div class="bottomFiller"/>
  </v-container>
</template>

<script>
import AddToCart from "@/app/cart/addToCart";
import AddToInventory from '@/app/inventory/addToInventory'
import AddToLabels from "@/app/label/addToLabels"
import axios from "axios";
import {mapActions, mapGetters} from 'vuex'
import router from '@/router'
import NotesSmall from "@/assets/notesSmall";
import Fsk18 from "@/assets/fsk18";
import {api} from "@/config/api";
import AddToMHDInventory from "@/app/mhdinventory/addToMHDInventory.vue";
export default {
  name: "productDetails",
  components: {AddToMHDInventory, Fsk18, NotesSmall, AddToCart, AddToLabels, AddToInventory},

  data:() => {
    return {
      isLoading: true,
      article: null,
      notFound: false,
      productImage: null,
      imageLoading: true,

      watchlistSet: null,
      articleInfoTextRedirect: 'articleInfoTextRedirect',
      articleStatusNotAvailable: 'articleStatusNotAvailable',
      baseUrl: api.url
    }
  },

  methods: {
    ...mapActions({
      setLastWatched: 'setLastWatched',
      setWatchList: 'setWatchList',
      setHeaderVisibility: 'setHeaderVisibility',
      getArticlePic: 'getArticlePic'
    }),

    goBack() {
      router.go(-1)
    },

    getPriceAvailability(article) {
      if(article.price.length === 0 && article.default_price !== null) {
        if(article.default_price.uvp !== null) {
          return true
        }
        else {return false}
      }
    },

    setToWatchList() {
      this.setWatchList(this.article.id)
      //this.watchlistSet = !this.watchlistSet
    },

    loadProductDetails(artNr) {
      axios.get('/api/products/'+artNr)
          .then((result) => {
            if (Object.keys(result.data).length > 0) {
              this.article = result.data[0]
              this.setLastWatched(this.article.id)
            }
            else {
              this.notFound = true
            }
          })
          .finally(() => this.isLoading = false)
    },

    async loadProductImage(artNr) {
      this.imageLoading = true

      try {
        await axios.get('/api/pic/'+artNr,{ responseType: 'arraybuffer'})
        .then((result) => {
          let image = btoa(
              new Uint8Array(result.data)
                  .reduce((data, byte) => data + String.fromCharCode(byte), '')
          );
          this.productImage =  `data:${result.headers['content-type'].toLowerCase()};base64,${image}`
          this.imageLoading = false
        })
        .catch(() => {

        })
      }
      catch (err) {
        console.log(err)
      }
    },

    parseArtNrFromInfo(infoText) {
      let artNr = /\d{5}/.exec(infoText)
      if(artNr !== null) {
        return artNr[0]
      }
      else {
        return 0
      }
    },

    goToArticle(artNr) {
      this.$router.push({path: `/shop/article/${artNr}`})
    }
  },

  mounted() {
    this.setHeaderVisibility(false)
    let artNr = this.$route.params.id
    this.loadProductDetails(artNr)
    // this.loadProductImage(artNr)
  },

  beforeRouteUpdate(to, from, next) {
    this.productImage = null
    this.article = null
    this.notFound = false
    this.isLoading = true
    this.loadProductDetails(to.params.id)
    // this.loadProductImage(to.params.id)
    next()
  },

  computed: {
    ...mapGetters({
      getUserId: 'getUserId',
      isLogged: 'isLogged',
      getWatchList: 'getWatchList',
      getCartContents: 'getCartContents',
      getPermissions: 'getPermissions'
    }),

    ...mapGetters('inventory', {
      getInventoryMode: 'getInventoryMode'
    }),
    articleInCart () {
      let inCart = false
      this.getCartContents.forEach(el => {
        if(el.itemNo === this.article.itemNo) {
          inCart = true
        }
      })
      return inCart
    },
    latestOrderDate () {
      if (this.article.latest_order_date) {
        return new Date(this.article.latest_order_date).toLocaleDateString('de-DE', {day: '2-digit', month: '2-digit', year: '2-digit'})
      }
      return this.article.latest_order_date
    },
    /*
    watchListSet() {
      if(this.getWatchList().includes(this.article.id)) {
        console.log("not found")
        console.log(this.getWatchList())
        return false
      }
      else {
        console.log("found")
        console.log(this.getWatchList())
        return true
      }
    },
    */

    getWatched() {
      return this.getWatchList.findIndex(el => el == this.article.id) > -1
    }
  },
}
</script>

<style>

.articleInfoTextRedirect{
  cursor: pointer;
}

</style>
